<template>
    <div class="box effect1">
        <FocusEventsBySite
            :data="focusEventsMappedBySite"
        />
    </div>
    <div class="box effect1">
        <FocusEventsByUser
            :data="focusEventsMappedByTeam"
        />
    </div>
</template>
<script
    setup
    lang="ts"
  >
import { FocusSummary } from '@/types/interactionSummary';
import FocusEventsByUser from './focusEventsByUserTable/FocusEventsByUser.vue';
import FocusEventsBySite from './focusEventsBySiteTable/FocusEventsBySite.vue';
import { mapFocusEventsBySite, mapFocusEventsByTeam } from './utils/mapFocusEvents';
import { defineProps } from 'vue';
type FocusEventsProps = {
    data: FocusSummary[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teams: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    users: any[];
}
const props = defineProps<FocusEventsProps>();
const focusEventsMappedBySite = mapFocusEventsBySite(props.data, props.config, props.users);
const focusEventsMappedByTeam = mapFocusEventsByTeam(props.data, props.teams, props.users, props.config);
</script>
<style lang="scss">
.box {
  margin: 2.5vw auto;
  background: #FFF;
  border: 1px solid #DCE3E4;
}
.effect1{
  -webkit-box-shadow: 0 10px 6px -6px #DCE3E4;
    -moz-box-shadow: 0 10px 6px -6px #DCE3E4;
      box-shadow: 0 10px 6px -6px #DCE3E4;
}

</style>